import { render, staticRenderFns } from "./WaitModal.vue?vue&type=template&id=5bd38b52&scoped=true&"
import script from "./WaitModal.vue?vue&type=script&lang=ts&"
export * from "./WaitModal.vue?vue&type=script&lang=ts&"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd38b52",
  null
  
)

export default component.exports